import React from "react";
import { Button } from "../../../../../shadcn/components/ui/button";
import Dot from "../../../../../icons/Dot";
import { Progress } from "../../../../../shadcn/components/ui/progress";
interface WrapperPropertiesCardProps {
  cardType: "kyc" | "auction";
  showTag?: boolean;
  tagText?: string;
  showId?: boolean;
  id?: string | number;
  imgLink?: string;
  svgElement?: React.ReactNode;
  headingText?: string;
  subHeadingIcon?: React.ReactNode;
  subHeadingText?: string;
  showCTA?: boolean;
  ctaText?: string;
  ctaSubText?: string | boolean;
  status?: string;
  progressValue?: number;
  hours?: any;
  minutes?: any;
  seconds?: any;
  isDisabled?: boolean;
  onclickHandler?: () => void;
  styles?: {
    tagStyle?: string;
    idStyle?: string;
    imgStyle?: string;
    CTAStyle?: string;
  };
}

export default function WrapperPropertiesCard({
  cardType,
  showTag = false,
  tagText = "KYC Incomplete",
  showId = true,
  id,
  imgLink,
  svgElement,
  headingText,
  subHeadingIcon,
  subHeadingText,
  showCTA,
  ctaText,
  ctaSubText = false,
  styles,
  status,
  progressValue = 30,
  onclickHandler,
  hours,
  minutes,
  seconds,
  isDisabled = false,
}: WrapperPropertiesCardProps) {
  return (
    <div
      className={`relative ${
        cardType === "auction"
          ? ""
          : "w-full min-w-[300px] mid:min-w-[400px] xl:min-w-[410px]"
      } `}
    >
      {showTag && (
        <div
          className={`absolute left-0 top-0 pl-4 py-1 pr-9 uppercase font-sans text-xs md:text-sm  ${styles?.tagStyle}`}
          style={{
            clipPath: "polygon(0% 0%, 85% 0%, 100% 100%, 100% 100%, 0% 100%)",
          }}
        >
          {tagText}
        </div>
      )}
      {showId && cardType === "auction" && (
        <div
          className={`absolute right-4 md:right-12 top-1 md:top-3 pl-4 py-1 md:pr-9 uppercase font-sans text-sm  ${styles?.idStyle}`}
        >
          <div className="bg-white py-1 px-3 lg:px-4 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
            <Dot />
            <span className="text-[12px] lg:text-xs font-sans pl-3 font-normal text-brand-textBlack tracking-widest">
              ID {id}
            </span>
          </div>
        </div>
      )}
      {showId && cardType === "kyc" && (
        <div
          className={`absolute right-2 md:right-2 top-1 md:top-1 pl-4 sm:py-1 md:pr-9 uppercase font-sans text-xs ${styles?.idStyle}`}
        >
          <div className="bg-white py-1 px-3 mid:px-4 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
            <Dot />
            <span className="text-[10px] lg:text-[8px] font-sans pl-3 font-normal text-brand-textBlack tracking-wide">
              ID {id}
            </span>
          </div>
        </div>
      )}
      <div className="flex flex-col md:flex-row pt-14 pb-4 md:pb-0 md:pt-12 px-4 gap-4 w-full">
        <div className="">
          {imgLink && (
            <div>
              <img
                src={imgLink}
                className={`${styles?.imgStyle}`}
                alt="img_of_card"
              />
            </div>
          )}
          {svgElement && <div>{svgElement}</div>}{" "}
        </div>
        <div className="justify-self-stretch flex flex-col justify-between w-full">
          <div className="flex flex-col">
            {headingText && (
              <h3 className="text-brand-textBlack font-sans text-lg xl:text-xl font-semibold capitalize">
                {headingText}
              </h3>
            )}
            {subHeadingText && (
              <div className="flex items-start mt-3 capitalize">
                {subHeadingIcon && (
                  <div className="mr-1 mt-1">{subHeadingIcon}</div>
                )}
                <div className="text-[11px] xl:text-sm max-w-[183px] text-brand-textGrey">
                  {subHeadingText}
                </div>
              </div>
            )}
          </div>
          {cardType === "auction" && (
            <div className="pr-0 pt-8 md:pt-0 md:pr-20">
              {status === "live" && (
                <div className="flex justify-between w-full mb-3">
                  <div className="text-brand-textLightGrey font-sans">
                    Ends in
                  </div>
                  <div
                    className={`${
                      hours <= 0 && minutes < 5
                        ? "text-red-600"
                        : "text-[#4DBB3E]"
                    }`}
                  >
                    {/* {hours}:{minutes}:{seconds} */}
                    <>
                      {status === "live"
                        ? hours < 10
                          ? hours > 0
                            ? `0${hours}`
                            : "00"
                          : hours
                        : "00"}
                      :
                      {status === "live"
                        ? minutes < 10
                          ? minutes > 0
                            ? `0${minutes}`
                            : "00"
                          : minutes
                        : "00"}
                      :
                      {status === "live"
                        ? seconds < 10
                          ? seconds > 0
                            ? `0${seconds}`
                            : "00"
                          : seconds
                        : "00"}
                    </>
                  </div>
                </div>
              )}
              {status === "accepted" && (
                <div className="flex justify-between items-center w-full mb-3">
                  <div className="text-brand-textLightGrey font-sans">
                    Starting in
                  </div>
                  <div className="text-red-600 text-sm">
                    {/* {hours}:{minutes}:{seconds} */}
                    <>
                      {status === "accepted"
                        ? hours < 10
                          ? hours > 0
                            ? `0${hours}`
                            : "00"
                          : hours
                        : "00"}
                      :
                      {status === "accepted"
                        ? minutes < 10
                          ? minutes > 0
                            ? `0${minutes}`
                            : "00"
                          : minutes
                        : "00"}
                      :
                      {status === "accepted"
                        ? seconds < 10
                          ? seconds > 0
                            ? `0${seconds}`
                            : "00"
                          : seconds
                        : "00"}
                    </>
                  </div>
                </div>
              )}

              <Progress
                value={progressValue}
                className="h-1"
                fillColor="bg-[#5D5FEF]"
              />
            </div>
          )}
          <div className="md:flex">
            {showCTA && (
              <div className="mt-8 md:mt-0">
                <Button
                  className={`w-full bg-white text-brand-textBlack border border-brand-borderGrey hover:bg-white hover:text-brand-textBlack hover:shadow-md px-14 ${styles?.CTAStyle}`}
                  onClick={onclickHandler}
                  disabled={isDisabled}
                >
                  {ctaText}
                </Button>
                {ctaSubText && (
                  <div className="text-[10px] font-openSans text-brand-orange text-center py-[1px]">
                    {ctaSubText}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
